import { RootState } from '../..';

export const selectAuth = (state: RootState) => state.auth;
